(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["solstar-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-solstar-stats]').forEach((section) => {
        if (section.dataset.solstarStatsInitialized === 'true') return;
        section.dataset.solstarStatsInitialized = 'true';

        const items = section.querySelectorAll('.solstar-stats__item');
        const values = section.querySelectorAll('.solstar-stats__value');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let animated = false;

        const revealItems = () => {
          items.forEach((item, index) => {
            item.style.transitionDelay = `${index * 0.12}s`;
            item.classList.add('is-visible');
          });
        };

        const animateNumbers = () => {
          if (animated) return;
          animated = true;

          values.forEach((element) => {
            const target = Number.parseFloat(element.dataset.value || '0');
            const decimals = Number.parseInt(element.dataset.decimals || '0', 10);
            const suffix = element.dataset.suffix || '';
            const duration = 1500;
            let start;

            const step = (timestamp) => {
              start ??= timestamp;
              const progress = Math.min((timestamp - start) / duration, 1);
              const easedProgress = 1 - Math.pow(1 - progress, 3);
              element.textContent = `${(target * easedProgress).toFixed(decimals)}${suffix}`;

              if (progress < 1) window.requestAnimationFrame(step);
            };

            element.textContent = `${(0).toFixed(decimals)}${suffix}`;
            window.requestAnimationFrame(step);
          });
        };

        const runAnimation = () => {
          revealItems();
          animateNumbers();
        };

        if (reduceMotion) {
          revealItems();
          return;
        }

        section.classList.add('is-animated');

        if (!('IntersectionObserver' in window)) {
          runAnimation();
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            runAnimation();
            observer.disconnect();
          }
        }, { threshold: 0.2 });

        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
